export default{
    wcOrder:{
        table:{
            tab1:'Approved Merchant',
            tab2:'Unbilled Amount',
            tab3:'Remaining Credit',
            tab4:'Payment Term Type',
            tab5:'Statement Date',
            tab6:'Final Repayment Deadline',
            tab7:'Action',
        },
        msgState:{
            msg1:'Bill Generation',
            msg2:'Monthly on the',
            msg3:'day',
            msg4:'Every',
            msg5:'natural days'
        },
        btnState:{
            btn1:'Early Settlement',
        }
    }
}